// extracted by mini-css-extract-plugin
export default {"hero":"content_hero__Gg3to"};